"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventProperty = exports.ArrayOfObjectType = void 0;
require("reflect-metadata");
const EventSchema_1 = require("./EventSchema");
class ArrayOfObjectType {
    constructor(itemsType) {
        this.itemsType = itemsType;
    }
}
exports.ArrayOfObjectType = ArrayOfObjectType;
function getPropertySchema(type) {
    let propertyType;
    switch (type) {
        case String:
            propertyType = { type: "string" };
            break;
        case Number:
            propertyType = { type: "double" };
            break;
        case Boolean:
            propertyType = { type: "boolean" };
            break;
        case Array:
            throw new Error("Array must be typed");
        case Function:
            throw new Error("Functions not allowed as event properties");
        default:
            if (type instanceof ArrayOfObjectType) {
                propertyType = { type: "array" };
                const subSchema = EventSchema_1.getEventSchema(type.itemsType);
                if (subSchema) {
                    propertyType.properties = [
                        {
                            name: "_items",
                            isOptional: false,
                            type: "object",
                            properties: subSchema.properties,
                        },
                    ];
                }
                else {
                    propertyType.properties = [
                        {
                            name: "_items",
                            isOptional: false, ...getPropertySchema(type.itemsType),
                        },
                    ];
                }
            }
            else {
                const subProperties = EventSchema_1.getEventPropertiesSchema(type);
                if (!subProperties) {
                    throw new Error("Nested objects must be typed with decorated properties");
                }
                propertyType = { type: "object" };
                propertyType.properties = subProperties;
            }
    }
    return propertyType;
}
function EventProperty(parameters = {}) {
    return (target, key) => {
        var _a;
        const schemas = (_a = EventSchema_1.getEventPropertiesSchema(target.constructor)) !== null && _a !== void 0 ? _a : [];
        if (schemas.length === 0) {
            EventSchema_1.setEventPropertiesSchema(target.constructor, schemas);
        }
        const type = parameters.type ? parameters.type({ arrayOf: (t) => new ArrayOfObjectType(t) }) : Reflect.getMetadata("design:type", target, key);
        if (!type || type === Object) {
            throw new Error(`Type of property ${target.constructor.name}.${key} is not supported`);
        }
        const property = {
            name: key,
            isOptional: !!parameters.optional,
            ...getPropertySchema(type),
        };
        schemas.push(property);
    };
}
exports.EventProperty = EventProperty;
//# sourceMappingURL=EventPropertyDecorator.js.map